<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container">
                <div class="modal-details-product">
                    <div class="modal-header">
                        <div class="modal-product-info">
                            <div class="product-info-top">
                                <span class="product-title">
                                    {{ capitalizeFirst(currentProductData.pro_descricao) }}
                                </span>
                                <div class="product-code">
                                    <span>{{ currentProductData.pro_codInterno }}</span>
                                </div>
                            </div>
                            <div class="product-info-bottom" v-if="cachedMetricsInfo">
                                <span>Atualizado em: {{ cachedMetricsInfo.lastUpdate | formatDate }}</span>
                            </div>
                        </div>
                        <button class="close-btn" @click="$emit('close')">
                            <span class="material-icons-outlined">close</span>
                        </button>
                    </div>
                </div>
                <div class="data-products">
                    <h5>Dados da Última Compra</h5>
                    <div class="cards-container">
                        <div v-for="(productData, index) in productsData" :key="index" class="card-product">
                            <p class="title">{{ productData.title }}</p>
                            <p class="value">{{ productData.value }}</p>
                        </div>
                    </div>
                </div>
                <div class="data-products">
                    <h5>Dados da Última Venda</h5>
                    <div class="cards-container">
                        <div class="card-product">
                            <p class="title">Data:</p>
                            <p class="value">{{ formattedLastSaleDate }}</p>
                        </div>
                        <div class="card-product">
                            <p class="title">Quantidade:</p>
                            <p class="value">{{ formattedLastSaleQuantity }}</p>
                        </div>
                        <div class="card-product">
                            <p class="title">Valor:</p>
                            <p class="value">{{ formattedLastSaleValue }}</p>
                        </div>
                    </div>
                </div>
                <div class="data-stock">
                    <h5>Dados do Estoque</h5>
                    <div class="cards-container">
                        <div v-for="(stock, index) in stocks" :key="index" class="card-stock">
                            <p class="title">{{ stock.title }}</p>
                            <p class="value">{{ stock.value }}</p>
                        </div>
                    </div>
                </div>
                <div class="data-analysis">
                    <h5>
                        Análise de Vendas dos
                        <select v-model="selectedDays">
                            <option v-for="day in daysOptions" :key="day" :value="day">
                                últimos {{ day }} dias
                            </option>
                        </select>
                    </h5>
                    <div class="cards-container">
                        <div v-for="(analysis, index) in analysis" :key="index" class="card-analysis">
                            <p class="title">{{ analysis.title }}</p>
                            <p class="value">{{ analysis.value }}</p>
                        </div>
                    </div>
                </div>
                <div class="data-chart">
                    <h5>Vendas x Compras</h5>
                    <div class="chart-container" v-if="hasChartData">
                        <canvas ref="salesPurchasesChart"></canvas>
                    </div>
                    <div class="chart-empty" v-else>
                        <span class="material-icons-outlined">show_chart</span>
                        <p>Sem dados de vendas ou compras para o período selecionado</p>
                    </div>
                </div>
                <div class="data-purchase purchase-history">
                    <h5>Últimas Compras</h5>
                    <div class="purchase-item" v-for="(item, index) in filteredPurchaseHistory"
                        :key="'purchase-' + index">
                        <div class="row" style="display: grid;grid-template-columns: 2fr 1fr 1fr 1fr 1fr;">
                            <div>
                                <strong>Fornecedor</strong>
                                <span>{{ item.nomefantasia }}</span>
                                <small>{{ formatCNPJ(item.cnpj) }}</small>
                            </div>
                            <div>
                                <strong>Data</strong>
                                <span>{{ formatDate(item.dataentrada) }}</span>
                            </div>
                            <div>
                                <strong>Qtd/Emb.</strong>
                                <span>{{ item.qtdembalagem }}</span>
                            </div>
                            <div>
                                <strong>Quantidade</strong>
                                <span>{{ item.quantidade }}</span>
                            </div>
                            <div>
                                <strong>Qtd Total</strong>
                                <span>{{ item.quantidade_total }}</span>
                            </div>
                        </div>

                        <hr />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import Chart from "chart.js";
import Select from "../cliente/base-components/Select.vue";
import QuotationService from "@/services/QuotationService";
import ProductService from "@/services/v2/products.service";
import difLine from "../lists/difLine.vue";
import ProductWrapModal from "@/modals/product-wrap/product-wrap.modal";

export default {
    components: {
        Select,
        difLine,
        ProductWrapModal,
    },
    props: {
        productsList: {
            type: Array,
            required: true
        },
        product: {
            type: Object,
            required: true
        },
        productIndex: {
            type: Number,
            default: 0
        },
        quotationId: {
            type: Number,
            default: null,
        },
        proId: {
            type: Number,
            required: true,
        },
        cliId: {
            type: Number,
            required: true,
        },
        storeNumber: {
            type: Number,
            required: true,
            default: 1
        },
        inputQuantity: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            allPurchaseHistory: [],
            allSaleHistory: [],
            filteredPurchaseHistory: [],
            filteredSaleHistory: [],
            loading: false,
            periodFilter: "all",
            salesPeriodFilter: "all",
            apiBaseUrl: process.env.VUE_APP_MIRAI_BASE_URL || "https://api-integration.clubdacotacao.com.br/v3/intelligence",
            currentProduct: 1,
            totalProducts: 5,
            selectedDays: 90,
            daysOptions: [7, 14, 30, 90],
            isEditing: false,
            editedQuantity: 0,
            metricsData: null,
            purchasePending: 0,
            stocks: [
                { title: "Estoque Atual", value: " " },
                { title: "Cobertura de Estoque", value: " " },
                { title: "Pendência de Compra", value: " " },
                { title: "Cobertura Prevista", value: " " },
            ],
            analysis: [
                { title: "Venda Total", value: " " },
                { title: "Giro Diário", value: " " },
                { title: "Média Semanal", value: " " },
                { title: "Média Mensal", value: " " },
            ],
            productsData: [
                { title: "Data", value: " " },
                { title: "Quantidade", value: " " },
                { title: "Valor", value: " " },
            ],
            periodFilter: "all",
            salesPeriodFilter: "all",
            quotationService: new QuotationService(),
            productService: new ProductService(),
            previousQuantity: 0,
            open_edit_wrap: false,
            current_product: null,
            localProductIndex: 0,

            currentProductIdentifier: null,
            dataLoadTimeout: null,
            quantityTimeout: null,
            isDataLoading: false,
            hasLoadedPurchaseHistory: false,
            hasLoadedSaleHistory: false,
            hasLoadedMetrics: false,
            currentIndex: 0,
            currentProduct: null,
            chartInstance: null,
            hasChartData: false,
            cachedMetricsInfo: null,

        };
    },
    created() {
        this.currentProduct = { ...this.product };
        this.currentIndex = this.actualProductIndex;

        this.$nextTick(() => {
            this.loadProductData();
        });
    },
    computed: {
        lastSale() {
            const product = this.metricsData?.product;
            if (!product) return null;
            return { quantidade: product.last_sale_quantity, valortotal: product.last_sale_value };
        },
        formattedLastSaleDate() {
            if (!this.cachedMetricsInfo || !this.cachedMetricsInfo.lastSale) return '--';
            const filter = this.$options.filters.formatDateOnly;
            return filter ? filter(this.cachedMetricsInfo.lastSale) : this.formatDate(this.cachedMetricsInfo.lastSale);
        },
        formattedLastSaleQuantity() {
            if (!this.lastSale || !this.lastSale.quantidade) return '--';
            return this.lastSale.quantidade + ' uni.';
        },
        formattedLastSaleValue() {
            if (!this.lastSale || this.lastSale.valortotal == null) return '--';
            return this.$options.filters.currency(this.lastSale.valortotal);
        },
        storeSalesMetrics() {
            const networkSales = this.metricsData?.network_sales || [];
            return networkSales.find(item => String(item.id_loja) === String(this.safeStoreNumber)) || null;
        },

        currentProductKey() {
            const product = this.currentProductData;
            if (!product || !product.pro_codInterno) return null;
            return `${product.pro_codInterno}_${this.safeStoreNumber}`;
        },

        currentProductData() {
            return this.product || {};
        },

        computedQuantity() {
            const product = this.getCurrentProduct();
            if (!product) return 0;

            if (this.quantityInput && this.quantityInput > 0) {
                return this.quantityInput;
            } else if (product.quantidadeDigitacao) {
                return product.quantidadeDigitacao;
            } else if (product.new_amount) {
                return parseFloat(product.new_amount) || 0;
            }
            return 0;
        },

        purchasesForCurrentProduct() {
            if (!this.filteredPurchaseHistory.length) return [];
            const currentProduct = this.getCurrentProduct();
            const currentProductId = currentProduct?.pro_codInterno;

            if (!currentProductId) return [];

            return this.filteredPurchaseHistory.filter((purchase) => {
                return purchase.id_produto == currentProductId;
            });
        },

        lastPurchaseForCurrentProduct() {
            if (this.purchasesForCurrentProduct.length > 0) {
                const sortedPurchases = [...this.purchasesForCurrentProduct].sort((a, b) => {
                    const dateA = new Date(a.dataentrada || a.dataemissao);
                    const dateB = new Date(b.dataentrada || b.dataemissao);
                    return dateB - dateA;
                });
                return sortedPurchases[0];
            }
            return null;
        },
        actualProductIndex() {
            if (!this.productsList || !this.currentProductData.pro_codInterno) return 0;

            const index = this.productsList.findIndex(p =>
                p.pro_codInterno === this.currentProductData.pro_codInterno
            );
            return index >= 0 ? index : 0;
        },
        safeStoreNumber() {
            return Number(this.storeNumber) || 1;
        }
    },
    methods: {
        formatCNPJ(cnpj) {
            if (!cnpj) return "";
            cnpj = String(cnpj).padStart(14, "0");
            return cnpj
                .replace(/^(\d{2})(\d)/, "$1.$2")
                .replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3")
                .replace(/\.(\d{3})(\d)/, ".$1/$2")
                .replace(/(\d{4})(\d)/, "$1-$2")
                .substring(0, 18);
        },
        calculateLastPurchasePrice(purchase) {
            if (!purchase || !purchase.valor) return 0;
            return purchase.valor * (purchase.qtdembalagem || 1);
        },
        calculatePackagePrice(unitPrice, product) {
            if (!unitPrice || !product) return 0;

            let quantityPerPackage = 1;

            if (product.embalagem) {
                const embParts = product.embalagem.split(" ");
                if (embParts.length > 1) {
                    quantityPerPackage = parseFloat(embParts[1]) || 1;
                }
            }
            return unitPrice * quantityPerPackage;
        },

        calculateTotalPrice(unitPrice, product) {
            if (!unitPrice || !product) return 0;

            const requestedQuantity =
                parseFloat(product.new_amount) || parseFloat(product.quantidade_sugestao) || 0;

            let quantityPerPackage = 1;
            if (product.embalagem) {
                const embParts = product.embalagem.split(" ");
                if (embParts.length > 1) {
                    quantityPerPackage = parseFloat(embParts[1]) || 1;
                }
            }

            return requestedQuantity * unitPrice * quantityPerPackage;
        },
        getDiff(produto) {
            if (localStorage.getItem("cli_utilizaPrecoBase") != 1) return "--";

            if (
                !produto ||
                !this.lastPurchaseForCurrentProduct ||
                !this.lastPurchaseForCurrentProduct.valor
            ) {
                return this.$options.filters.currency(0);
            }
            const lastPurchaseUnitPrice = this.lastPurchaseForCurrentProduct.valor;
            const digitacaoPrice = produto.menorPreco || 0;

            const difference = digitacaoPrice - lastPurchaseUnitPrice;

            return this.$options.filters.currency(difference);
        },
        getDiffs(product) {
            if (
                !product ||
                !this.lastPurchaseForCurrentProduct ||
                !this.lastPurchaseForCurrentProduct.valor
            ) {
                return 0;
            }

            const lastPurchaseUnitPrice = this.lastPurchaseForCurrentProduct.valor;
            const digitacaoPrice = product.menorPreco || 0;

            return digitacaoPrice - lastPurchaseUnitPrice;
        },

        getVar(product) {
            if (localStorage.getItem("cli_utilizaPrecoBase") != 1) return "--";
            if (!product) return "--";

            const diff = this.getDiffValue(product);

            let quantityPerPackage = 1;
            if (product.embalagem) {
                const embParts = product.embalagem.split(" ");
                if (embParts.length > 1) {
                    quantityPerPackage = parseFloat(embParts[1]) || 1;
                }
            }
            const requestedQuantity = parseFloat(product.quantidade_sugestao) || 0;
            const variation = diff * quantityPerPackage * requestedQuantity;

            return this.$options.filters.currency(variation);
        },
        getDigiTextColorStyle(product) {
            if (
                !product ||
                !product.menorPreco ||
                !this.lastPurchaseForCurrentProduct ||
                !this.lastPurchaseForCurrentProduct.valor
            ) {
                return "color: #605F5F; font-weight: 500; padding: 0.2rem; border-radius: 6px;";
            }

            const digitacaoUnitPrice = this.getNumber(product.menorPreco);
            const lastPurchaseUnitPrice = this.lastPurchaseForCurrentProduct.valor;

            if (digitacaoUnitPrice > lastPurchaseUnitPrice) {
                return "color: red; background-color: #FF80801A; border: 1px solid #FF5C5C; opacity: 0.5; padding: 0.2rem; border-radius: 16px;";
            }
            if (digitacaoUnitPrice < lastPurchaseUnitPrice) {
                return "color: green; background-color: rgb(214, 238, 214); border: 1px solid lightgreen; padding: 0.2rem; border-radius: 16px;";
            }
            return "color: #605F5F; font-weight: 500; padding: 0.2rem; border-radius: 16px;";
        },

        getNumber(value) {
            return typeof value === "number" ? value : parseFloat(value) || 0;
        },

        getDiffValue(produto) {
            if (
                !produto ||
                !this.lastPurchaseForCurrentProduct ||
                !this.lastPurchaseForCurrentProduct.valor
            ) {
                return 0;
            }

            const lastPurchaseUnitPrice = this.lastPurchaseForCurrentProduct.valor;
            const digitacaoUnitPrice = produto.menorPreco || 0;

            return digitacaoUnitPrice - lastPurchaseUnitPrice;
        },

        getEmbalagemUnit(embalagem) {
            if (!embalagem) return "UN";
            const parts = embalagem.split(" ");
            return parts.length > 0 ? parts[0] : "UN";
        },
        initializeProducts() {
            if (this.productsList && this.productsList.length > 0) {
                this.products = [...this.productsList];
                const productId = this.product?.pro_id || this.product?.idProduto;
                if (productId) {
                    const index = this.products.findIndex(p =>
                        p.pro_id === productId ||
                        p.idProduto === productId
                    );
                    if (index !== -1) {
                        this.localProductIndex = index;
                    }
                }
            }
            else if (this.product && Object.keys(this.product).length > 0) {
                this.products = [this.product];
                this.localProductIndex = 0;
            }
            else if (this.productsListProp && this.productsListProp.length > 0) {
                this.products = [...this.productsListProp];
                this.localProductIndex = this.currentProductIndex >= 0 ?
                    this.currentProductIndex : 0;
            }
            else {
                console.warn('Nenhum produto disponível para inicializar');
                this.products = [];
            }
            if (this.localProductIndex < 0) this.localProductIndex = 0;
            if (this.localProductIndex >= this.products.length && this.products.length > 0) {
                this.localProductIndex = this.products.length - 1;
            }
            this.scheduleDataLoad();
        },
        scheduleDataLoad() {
            if (this.dataLoadTimeout) {
                clearTimeout(this.dataLoadTimeout);
            }

            this.dataLoadTimeout = setTimeout(() => {
                this.fetchInitialData();
            }, 100);
        },

        getCurrentProduct() {
            if (this.products && this.products.length > 0) {
                const safeIndex = Math.max(0, Math.min(this.productIndex, this.products.length - 1));
            }

            if (this.product && Object.keys(this.product).length > 0) {
                return this.product;
            }
            return null;
        },

        initializeWithProps() {
            this.products = this.productsList && this.productsList.length > 0
                ? [...this.productsList]
                : this.product ? [this.product] : [];
            this.scheduleDataLoad();
        },
        async fetchInitialData() {
            const currentProduct = this.product;
            if (!currentProduct || !currentProduct.pro_codInterno) return;

            const newProductKey = this.currentProductKey;
            if (this.currentProductIdentifier === newProductKey) return;
            this.currentProductIdentifier = newProductKey;

            try {
                this.resetProductData();
                await this.fetchProductMetrics(currentProduct);
                this.$nextTick(() => this.renderChart());
            } catch (error) {
                console.error("Erro ao carregar dados do modal:", error);
            }
        },
        getProducts() {
            this.loading = true;

            var quotationService = QuotationService;
            quotationService
                .getProdutosDigitacaoComparativo(params.id, params.sellerid, params.sid)
                .then((response) => response.data)
                .then((data) => {
                    let productsArray = data.produtos;
                    productsArray.forEach((p) => {
                        p.new_amount = p.quantidade_sugestao;
                        p.firstValue = p.quantidade_sugestao;
                    });
                    this.products = productsArray;
                    this.total_items = data.total;
                    if (data.valorTotal) {
                        data.valorTotal.forEach((d) => (this.total_pre_orders += d.total));
                    }
                    this.loading = false;
                })
                .catch((error) => {
                    console.error("Erro ao carregar produtos:", error);
                    this.loading = false;
                });
        },

        async fetchProductMetrics(currentProduct) {
            try {
                this.loading = true;

                const productIdentifier = currentProduct.pro_codInterno || currentProduct.pro_ean;
                if (!productIdentifier) {
                    console.warn('Produto sem identificador para buscar histórico');
                    this.updateProductsData();
                    return;
                }

                const clientId = process.env.VUE_APP_MIRAI_CLI_ID || this.cliId || this.$store?.state?.user?.cli_id;
                const storeNumber = this.safeStoreNumber;

                if (!clientId || !storeNumber) {
                    console.warn('Dados do cliente ou loja não disponíveis');
                    this.updateProductsData();
                    return;
                }

                const url = `${this.apiBaseUrl}/product_metrics/${clientId}?id_loja=${storeNumber}&id_produto=${productIdentifier}`;
                const response = await axios.get(url);
                const metrics = response.data || {};
                this.metricsData = metrics;
                this.hasLoadedMetrics = true;

                this.allPurchaseHistory = (metrics.purchases || []).sort((a, b) => {
                    const dateA = new Date(a.dataentrada || a.dataemissao);
                    const dateB = new Date(b.dataentrada || b.dataemissao);
                    return dateB - dateA;
                });
                this.filteredPurchaseHistory = this.allPurchaseHistory;
                this.hasLoadedPurchaseHistory = true;
                this.updateProductsData();

                this.allSaleHistory = (metrics.sales || []).sort((a, b) => {
                    const dateA = new Date(a.data || a.dataentrada);
                    const dateB = new Date(b.data || b.dataentrada);
                    return dateB - dateA;
                });
                this.applySalesFilter();
                this.hasLoadedSaleHistory = true;
                this.calculateSalesAnalysis();
            } catch (error) {
                console.error("Erro ao buscar métricas do produto:", error);
            } finally {
                this.loading = false;
            }
        },

        getEmptyStockData() {
            return [
                { title: "Estoque Atual", value: "--" },
                { title: "Cobertura de Estoque", value: "--" },
                { title: "Pendência de Compra", value: "--" },
                { title: "Cobertura Prevista", value: "--" },
            ];
        },

        getEmptyAnalysisData() {
            return [
                { title: "Venda Total", value: "--" },
                { title: "Giro Diário", value: "--" },
                { title: "Média Semanal", value: "--" },
                { title: "Média Mensal", value: "--" },
            ];
        },
        calculateStockData() {
            if (!this.metricsData) {
                this.stocks = this.getEmptyStockData();
                this.analysis = this.getEmptyAnalysisData();
                return;
            }

            const currentStock = this.metricsData.stock?.current || 0;
            const stockCoverage = Number(this.metricsData.stock?.coverage) || 0;
            const purchasePending = this.metricsData.stock?.pending || 0;
            const weightedGiro = Number(this.storeSalesMetrics?.average) || 0;

            this.updateStockCards(
                currentStock,
                stockCoverage,
                purchasePending,
                weightedGiro
            );

            this.calculateSalesAnalysis();
        },

        calculateSalesAnalysis() {
            const totalSales = Number(this.storeSalesMetrics?.[`quantidade_total_${this.selectedDays}d`]) || 0;
            const dailyAverage = Number(this.storeSalesMetrics?.[`giro_medio_${this.selectedDays}d`]) || 0;

            this.updateAnalysisCards(dailyAverage, totalSales);
        },

        updateProductsData() {
            const lastPurchase = this.lastPurchaseForCurrentProduct;
            if (lastPurchase) {
                this.productsData = [
                    {
                        title: "Data",
                        value: this.formatDate(lastPurchase.dataentrada),
                    },
                    {
                        title: "Quantidade",
                        value: lastPurchase.quantidade_total ? `${lastPurchase.quantidade_total} uni.` : "--",
                    },
                    {
                        title: "Valor",
                        value: lastPurchase.valortotal
                            ? this.$options.filters.currency(lastPurchase.valor)
                            : "--",
                    },
                ];
            }
        },


        updateStockCards(currentStock, stockCoverage, purchasePending, weightedGiro) {
            const formattedPending = Number.isInteger(purchasePending)
                ? purchasePending
                : Math.ceil(purchasePending);

            const quantityInput = parseFloat(this.computedQuantity) || 0;
            const quantityToUse =
                this.currentProductData.flag_generico == 1 ||
                    (this.currentProductData.pro_principal == null &&
                        this.currentProductData.cli_tipoPedido == 1)
                    ? quantityInput
                    : quantityInput * (parseFloat(this.currentProductData.emb_quantidade) || 1);

            const forecastCoverage =
                weightedGiro > 0 && currentStock >= 0
                    ? (quantityToUse + currentStock) / weightedGiro
                    : 0;

            const formattedForecast = Number.isInteger(forecastCoverage)
                ? forecastCoverage
                : Math.ceil(forecastCoverage);

            const formattedStockCoverage = Number.isInteger(stockCoverage)
                ? stockCoverage
                : Math.ceil(stockCoverage);
            this.stocks = [
                {
                    title: "Estoque Atual",
                    value: `${currentStock} unidades`,
                },
                {
                    title: "Cobertura de Estoque",
                    value:
                        currentStock >= 0 && stockCoverage > 0
                            ? `${formattedStockCoverage} dias`
                            : "--",
                },
                {
                    title: "Pendência de Compra",
                    value: formattedPending > 0 ? `${formattedPending} unidades` : "--",
                },
                {
                    title: "Cobertura Prevista",
                    value: formattedForecast > 0 ? `${formattedForecast} dias` : "--",
                },
            ];
        },

        updateAnalysisCards(dailyAverage, totalSales) {
            if (!dailyAverage && !totalSales) {
                this.analysis = this.getEmptyAnalysisData();
                return;
            }

            const formattedTotalSales = Math.ceil(totalSales);
            const formattedDailyAverage = dailyAverage.toFixed(2);
            const weeklyAverage = (dailyAverage * 7).toFixed(2);
            const monthlyAverage = (dailyAverage * 30).toFixed(2);

            this.analysis = [
                {
                    title: "Venda Total",
                    value: formattedTotalSales > 0 ? `${formattedTotalSales} uni.` : "--",
                },
                {
                    title: "Giro Diário",
                    value: formattedDailyAverage > 0 ? `${formattedDailyAverage} uni./dia` : "--",
                },
                {
                    title: "Média Semanal",
                    value: weeklyAverage > 0 ? `${weeklyAverage} uni./sem` : "--",
                },
                {
                    title: "Média Mensal",
                    value: monthlyAverage > 0 ? `${monthlyAverage} uni./mês` : "--",
                },
            ];
        },

        async updateProductData() {
            const newProductKey = this.currentProductKey;
            if (newProductKey !== this.currentProductIdentifier) {
                this.allPurchaseHistory = [];
                this.allSaleHistory = [];
                this.filteredPurchaseHistory = [];
                this.filteredSaleHistory = [];
                this.metricsData = null;
                this.hasLoadedPurchaseHistory = false;
                this.hasLoadedSaleHistory = false;
                this.hasLoadedMetrics = false;
            }

            const hasValidIdentifier =
                this.currentProductData.pro_ean || this.currentProductData.pro_codInterno;

            if (!hasValidIdentifier) {
                this.stocks = this.getEmptyStockData();
                this.analysis = this.getEmptyAnalysisData();
                this.productsData = [
                    { title: "Data", value: "--" },
                    { title: "Quantidade", value: "--" },
                    { title: "Valor", value: "--" },
                ];
                return;
            }

            await this.fetchInitialData();
            this.updateProductsData();
        },

        formatDate(dateString) {
            if (!dateString) return "--";
            const options = { day: "2-digit", month: "2-digit", year: "numeric", timeZone: "UTC" };
            return new Date(dateString).toLocaleDateString("pt-BR", options);
        },

        formatNumber(value) {
            return Number.isInteger(value) ? value : Math.trunc(value);
        },
        applyPurchaseFilter() {
            if (this.selectedDays === "all") {
                this.filteredPurchaseHistory = this.allPurchaseHistory;
            } else {
                const days = parseInt(this.selectedDays);
                const cutoffDate = new Date();
                cutoffDate.setDate(cutoffDate.getDate() - days);

                this.filteredPurchaseHistory = this.allPurchaseHistory.filter((item) => {
                    const itemDate = new Date(item.dataentrada || item.dataemissao);
                    return itemDate >= cutoffDate;
                });
            }
        },

        applySalesFilter() {
            if (!this.allSaleHistory.length) {
                this.filteredSaleHistory = [];
                return;
            }

            if (this.selectedDays === "all") {
                this.filteredSaleHistory = this.allSaleHistory;
            } else {
                const days = parseInt(this.selectedDays);
                const cutoffDate = new Date();
                cutoffDate.setDate(cutoffDate.getDate() - days);

                this.filteredSaleHistory = this.allSaleHistory.filter((item) => {
                    if (!item.data) return false;

                    const itemDate = new Date(item.data);
                    return itemDate >= cutoffDate;
                });
            }

            this.calculateSalesAnalysis();
        },

        process_event_modal(event, product) {
            if (event.type === "blur" || event.key === "Enter") {
                this.update_quantity_modal(product);
            }
        },

        update_quantity_modal(product) {
            if (!product.new_amount) product.new_amount = "0";

            let payload = {
                numerocotacao: this.quotationId,
                quantidade: product.new_amount,
                vendedor: this.sellerId,
                produto: product.idProduto,
                loja: this.storeNumber,
            };

            this.$set(product, "is_loading", true);

            this.quotationService
                .update_quantity(payload)
                .then((response) => response.data)
                .then(
                    (data) => {
                        this.$set(product, "is_loading", false);
                        this.$set(product, "quantidade_sugestao", payload.quantidade);
                        this.$emit("quantity-updated");
                    },
                    (err) => {
                        this.$set(product, "is_loading", false);
                        console.error("Erro ao atualizar quantidade:", err);
                    }
                );
        },

        reload_subrequest_modal() {
            this.$emit("quantity-updated");
        },

        capitalizeFirst(str) {
            if (!str) return "";
            return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
        },
        canEditUnit(product) {
            return (
                product.flag_generico == 0 && !product.pro_principal && !this.subrequest.id_pedido
            );
        },

        edit_wrap(product) {
            this.current_product = product;
            this.open_edit_wrap = true;
        },

        close_wrap(reload = false) {
            this.current_product = null;
            this.open_edit_wrap = false;
            if (reload) {
                this.updateProductData();
            }
        },
        handleKeydown(event) {
            if (event.key === "Tab") {
                event.preventDefault();
                event.stopPropagation();

                if (event.shiftKey) {
                    this.prevProduct();
                } else {
                    this.nextProduct();
                }
            }
        },

        emitProductChange() {
            this.$emit("product-change", this.localProductIndex);
        },
        processMatrixData() {
            const currentProduct = this.currentProductData;
            if (currentProduct) {
                if (currentProduct.preco_ultima_compra) {
                    this.productsData = [
                        {
                            title: "Data",
                            value: currentProduct.data_ultima_compra || "--"
                        },
                        {
                            title: "Quantidade",
                            value: currentProduct.quantidade_ultima_compra
                                ? `${currentProduct.quantidade_ultima_compra} uni.`
                                : "--"
                        },
                        {
                            title: "Valor",
                            value: currentProduct.preco_ultima_compra
                                ? this.$options.filters.currency(currentProduct.preco_ultima_compra)
                                : "--"
                        },
                    ];
                }
                if (currentProduct.estoque !== undefined) {
                    this.stocks = [
                        {
                            title: "Estoque Atual",
                            value: currentProduct.estoque !== null
                                ? `${currentProduct.estoque} unidades`
                                : "--"
                        },
                        {
                            title: "Cobertura de Estoque",
                            value: "--"
                        },
                        {
                            title: "Pendência de Compra",
                            value: "--"
                        },
                        {
                            title: "Cobertura Prevista",
                            value: "--"
                        },
                    ];
                }
            }
        },
        async loadProductData() {
            const product = this.currentProductData;

            if (!product || !product.pro_codInterno) {
                console.warn('Produto inválido para carregar dados');
                return;
            }

            this.resetData();

            try {
                await this.fetchProductMetrics(product);

                this.$nextTick(() => this.renderChart());
            } catch (error) {
                console.error('Erro ao carregar dados:', error);
            }
        },

        loadHistoryData() {
            if (!this.currentProductData) return;
            this.fetchProductHistory().then(data => {
                this.productsData = this.formatProductsData(data);
                this.stocks = this.formatStocksData(data);
                this.analysis = this.formatAnalysisData(data);
                this.purchaseHistory = this.formatPurchaseHistory(data);
            });
        },

        resetProductData() {
            this.allPurchaseHistory = [];
            this.allSaleHistory = [];
            this.filteredPurchaseHistory = [];
            this.filteredSaleHistory = [];
            this.metricsData = null;
            this.purchasePending = 0;

            this.hasLoadedPurchaseHistory = false;
            this.hasLoadedSaleHistory = false;
            this.hasLoadedMetrics = false;
            this.stocks = this.getEmptyStockData();
            this.analysis = this.getEmptyAnalysisData();
            this.productsData = [
                { title: "Data", value: "--" },
                { title: "Quantidade", value: "--" },
                { title: "Valor", value: "--" },
            ];
        },

        resetDataAndLoad() {
            this.resetProductData();
            this.$nextTick(() => {
                this.fetchInitialData();
            });
        },
        resetData() {
            this.allPurchaseHistory = [];
            this.allSaleHistory = [];
            this.filteredPurchaseHistory = [];
            this.filteredSaleHistory = [];
            this.metricsData = null;

            this.resetCards();
        },
        resetCards() {
            this.stocks = [
                { title: "Estoque Atual", value: "--" },
                { title: "Cobertura de Estoque", value: "--" },
                { title: "Pendência de Compra", value: "--" },
                { title: "Cobertura Prevista", value: "--" },
            ];

            this.analysis = [
                { title: "Venda Total", value: "--" },
                { title: "Giro Diário", value: "--" },
                { title: "Média Semanal", value: "--" },
                { title: "Média Mensal", value: "--" },
            ];

            this.productsData = [
                { title: "Data", value: "--" },
                { title: "Quantidade", value: "--" },
                { title: "Valor", value: "--" },
            ];
        },

        renderChart() {
            if (this.chartInstance) {
                this.chartInstance.destroy();
                this.chartInstance = null;
            }

            const cutoffDate = new Date();
            cutoffDate.setDate(cutoffDate.getDate() - this.selectedDays);

            const dateMap = {};

            this.allSaleHistory.forEach(sale => {
                const date = sale.data;
                if (date && new Date(date) >= cutoffDate) {
                    dateMap[date] = dateMap[date] || { sales: 0, purchases: 0 };
                    dateMap[date].sales += sale.quantidade || 0;
                }
            });

            this.allPurchaseHistory.forEach(purchase => {
                const date = purchase.dataentrada;
                if (date && new Date(date) >= cutoffDate) {
                    dateMap[date] = dateMap[date] || { sales: 0, purchases: 0 };
                    dateMap[date].purchases += purchase.quantidade_total || 0;
                }
            });

            const existingDates = Object.keys(dateMap).sort();
            if (existingDates.length === 0) {
                this.hasChartData = false;
                return;
            }

            this.hasChartData = true;

            this.$nextTick(() => {
            const canvas = this.$refs.salesPurchasesChart;
            if (!canvas) return;

            const startDate = new Date(existingDates[0]);
            const endDate = new Date();
            endDate.setHours(0, 0, 0, 0);
            const sortedDates = [];
            for (let d = new Date(startDate); d <= endDate; d.setDate(d.getDate() + 1)) {
                const iso = d.toISOString().split('T')[0];
                sortedDates.push(iso);
                if (!dateMap[iso]) dateMap[iso] = { sales: 0, purchases: 0 };
            }

            const salesData = sortedDates.map(d => dateMap[d].sales);
            const purchasesData = sortedDates.map(d => dateMap[d].purchases);
            const labels = sortedDates.map(d => {
                const [y, m, day] = d.split('-');
                return `${day}/${m}`;
            });

            const ctx = canvas.getContext('2d');
            this.chartInstance = new Chart(ctx, {
                type: 'line',
                data: {
                    labels,
                    datasets: [
                        {
                            label: 'Vendas (qtd)',
                            data: salesData,
                            borderColor: '#4CAF50',
                            backgroundColor: 'rgba(76, 175, 80, 0.1)',
                            borderWidth: 2,
                            pointRadius: 3,
                            pointBackgroundColor: '#4CAF50',
                            fill: true,
                        },
                        {
                            label: 'Compras (qtd)',
                            data: purchasesData,
                            borderColor: '#F44336',
                            backgroundColor: 'rgba(244, 67, 54, 0.1)',
                            borderWidth: 2,
                            pointRadius: 3,
                            pointBackgroundColor: '#F44336',
                            fill: true,
                        }
                    ]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        xAxes: [{
                            ticks: {
                                fontSize: 10,
                                maxRotation: 45,
                                autoSkip: true,
                                maxTicksLimit: 15
                            }
                        }],
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                precision: 0
                            }
                        }]
                    },
                    legend: {
                        display: true,
                        position: 'top'
                    },
                    tooltips: {
                        mode: 'index',
                        intersect: false
                    }
                }
            });
            });
        },

        nextProduct() {
            if (this.products.length === 0) return;

            const newIndex = (this.productIndex + 1) % this.products.length;
            this.$emit('product-change', newIndex);
        },

        prevProduct() {
            if (this.products.length === 0) return;

            const newIndex = (this.productIndex - 1 + this.products.length) % this.products.length;
            this.$emit('product-change', newIndex);
        },

        handleKeydown(event) {
            if (event.key === 'Tab') {
                event.preventDefault();
                event.stopPropagation();

                if (event.shiftKey) {
                    this.prevProduct();
                } else {
                    this.nextProduct();
                }
            }
        },
    },
    watch: {
        productsList: {
            immediate: true,
            deep: true,
            handler(newList) {
                if (newList && newList.length > 0) {
                    this.products = [...newList];

                    if (this.localProductIndex >= this.products.length) {
                        this.localProductIndex = Math.max(0, this.products.length - 1);
                    }

                    if (!this.hasLoadedPurchaseHistory) {
                        this.$nextTick(() => {
                            this.fetchInitialData();
                        });
                    }
                }
            }
        },
        currentProductKey: {
            handler(newKey, oldKey) {
                if (newKey && newKey !== oldKey) {
                    this.resetDataAndLoad();
                }
            },
            immediate: true
        },
        "currentProductData.new_amount": {
            handler(newQuantity, oldQuantity) {
                if (newQuantity !== oldQuantity) {
                    clearTimeout(this.quantityTimeout);
                    this.quantityTimeout = setTimeout(() => {
                        this.calculateStockData();
                    }, 100);
                }
            },
            immediate: true,
            deep: true,
        },
        lastPurchaseForCurrentProduct: {
            handler(newVal) {
                if (newVal) {
                    this.updateProductsData();
                }
            },
            immediate: true,
            deep: true,
        },
        metricsData: {
            handler(newMetrics) {
                if (newMetrics) {
                    this.cachedMetricsInfo = {
                        lastUpdate: newMetrics.updatedAt,
                        lastSale: newMetrics.product ? newMetrics.product.last_sale : null,
                    };
                    this.$nextTick(() => {
                        this.calculateStockData();
                    });
                }
            },
            immediate: true,
            deep: true,
        },
        selectedDays: {
            handler() {
                this.applyPurchaseFilter();
                this.applySalesFilter();
                this.calculateSalesAnalysis();
                this.calculateStockData();
                this.$nextTick(() => this.renderChart());
            },
            immediate: true,
        },
        currentProductData: {
            handler(newProduct, oldProduct) {
                if (newProduct && oldProduct &&
                    newProduct.pro_codInterno !== oldProduct.pro_codInterno) {
                    this.fetchInitialData();
                }
            },
            deep: true
        },
        quantityInput(newQuantity, oldQuantity) {
            if (newQuantity !== oldQuantity) {
                this.calculateStockData();
            }
        },
        product: {
            handler(novo, antigo) {
                if (novo?.pro_codInterno && novo.pro_codInterno !== antigo?.pro_codInterno) {
                    this.fetchInitialData();
                }
            },
            immediate: true
        },
        productIndex: {
            handler(newIndex, oldIndex) {
                if (newIndex !== oldIndex) {
                    this.fetchInitialData();
                }
            }
        },
        storeNumber: {
            handler(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.fetchInitialData();
                }
            }
        },
    },
    filters: {
        currency(value) {
            if (value === null || value === undefined || isNaN(value)) return "R$ 0,00";
            const numValue = typeof value === "string" ? parseFloat(value) : value;
            return "R$ " + numValue.toFixed(2).replace(".", ",");
        },
        customCurrency(value) {
            if (value === null || value === undefined || isNaN(value)) return "R$ 0,00";
            const numValue = typeof value === "string" ? parseFloat(value) : value;
            return "R$ " + numValue.toFixed(2).replace(".", ",");
        },
    },
    mounted() {
        document.addEventListener("keydown", this.handleKeydown, true);
        if (!this.hasLoadedPurchaseHistory) {
            this.fetchInitialData();
        }
    },
    beforeUnmount() {
        document.removeEventListener("keydown", this.handleKeydown, true);
        if (this.chartInstance) {
            this.chartInstance.destroy();
            this.chartInstance = null;
        }
        if (this.dataLoadTimeout) {
            clearTimeout(this.dataLoadTimeout);
        }
        if (this.quantityTimeout) {
            clearTimeout(this.quantityTimeout);
        }
    },
};
</script>
<style lang="scss" scoped>
.modal-mask {
    padding-top: 64px;
    width: 25vw;
    min-width: 25vw;
    max-width: 25vw;
    height: 100%;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    flex-shrink: 0;
}

.modal-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    border-left: 1px solid #e5e5e5;
    box-shadow: -2px 0 8px rgba(0, 0, 0, 0.08);
    overflow: hidden;
}

.modal-container {
    border-radius: 8px;
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow-y: auto;
    scrollbar-gutter: stable;

    &::-webkit-scrollbar {
        width: 3px;
        height: 4px;
    }

    &::-webkit-scrollbar-track {
        background: #f8f6f6;
        border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
        background: #f8f6f6;
        border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background: #f8f6f6;
    }
}

.modal-header {
    padding: 16px 10px;
    color: #3a3a3c;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border: none;
    flex-shrink: 0;

    h2 {
        margin: 0;
        font-size: 1rem;
        font-weight: 600;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        max-width: calc(100% - 40px);
    }
}

.close-btn {
    background: transparent;
    border: none;
    color: #424242;
    cursor: pointer;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.modal-details-product {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 97%;
    margin: 0 auto;
    padding: 16px 0px;
    border-bottom: 1px solid #c7c9d9;
    flex-shrink: 0;
}

.modal-product-info {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .product-info-top {
        display: flex;
        align-items: center;
        gap: 16px;
    }

    .product-info-bottom {
        display: flex;
        align-items: center;
        gap: 16px;
        font-size: 0.875rem;
        color: #605f5f;
    }

    .product-title {
        color: #3a3a3c;
        font-size: 20px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        letter-spacing: -0.4px;
        text-transform: capitalize;
    }

    .product-code {
        display: flex;
        padding: 4px 8px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        border-radius: 16px;
        border: 1px solid #c7c9d9;
        background: #f2f2f5;

        span {
            color: #605f5f;
            font-size: 0.875rem;
            font-style: normal;
            font-weight: 300;
            line-height: normal;
        }
    }
}

.modal-body {
    padding: 20px;
    overflow-y: auto;
    flex: 1;
}

.space-modal {
    display: flex;
    justify-content: space-between;
    margin-bottom: 16px;
}

.space-modal-flex {
    display: flex;
    align-items: center;
    gap: 12px;

    span {
        color: #3a3a3c;
        font-size: 0.875rem;
        font-weight: 500;
    }
}

.data-products {
    padding: 16px 20px 0px;
    margin-bottom: 20px;
}

.loading-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 20px 0;

    .spinner {
        border: 3px solid rgba(0, 0, 0, 0.1);
        border-radius: 50%;
        border-top: 3px solid #FF5722;
        width: 30px;
        height: 30px;
        animation: spin 1s linear infinite;
        margin-bottom: 10px;
    }

    p {
        color: #666;
        margin: 0;
    }
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.empty-state {
    text-align: center;
    padding: 40px 0;
    color: #666;
    font-size: 1rem;
}

.table-responsive {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    max-height: 400px;
}

.purchase-history {
    width: 100%;
    margin: 2px 0;
    color: #3a3a3c;
    font-size: 1rem;
    font-weight: 500;

    h4 {
        margin-bottom: 10px;
        padding-left: 0;
    }

    .purchase-item {
        margin-bottom: 10px;
        padding-left: 0px;

        .row {
            display: flex;
            justify-content: space-between;
            padding: 10px 0;
            margin-left: 0;
            margin-right: 0;
            flex-wrap: nowrap;

            div {
                flex: 1;
                min-width: 0;
                display: flex;
                padding: 8px 5px;
                flex-direction: column;
                gap: 2px;
            }

            div:first-child {
                padding-left: 0;
            }

            div:last-child {
                padding-right: 0;
            }

            strong {
                white-space: nowrap;
                font-size: 0.7rem;
            }

            span {
                font-weight: 500;
                font-size: 0.75rem;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            small {
                font-weight: 400;
                font-size: 0.65rem;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

        }
    }

    hr {
        border: none;
        border-top: 1px solid #c7c9d9;
        margin: 8px 0;
    }
}

.data-stock,
.data-analysis {
    display: flex;
    flex-direction: column;
    padding: 16px 20px;
}

.cards-container {
    display: flex;
    gap: 14px;
    overflow: auto;
    flex-wrap: wrap;
}

.card-stock,
.card-analysis,
.card-product {
    flex: 1;
    border-radius: 8px;
    padding: 0px 12px;
    text-align: left;
    border: 1px solid #c7c9d9;
    margin-top: 7px;
    display: flex;
    flex-direction: column;

    .title {
        color: #3a3a3c;
        font-size: 0.875rem;
        font-weight: 500;
    }

    .value {
        color: #FF5722;
        font-weight: 700;
        font-size: 1rem;
    }
}

.card-product {
    background: #fff8e1;
}

.data-analysis {
    padding: 17px 20px;
}

.data-chart {
    padding: 16px 20px;

    h4 {
        margin-bottom: 10px;
    }

    .chart-container {
        position: relative;
        height: 220px;
        width: 100%;
    }

    .chart-empty {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 180px;
        border: 1px dashed #c7c9d9;
        border-radius: 8px;
        color: #999;

        .material-icons-outlined {
            font-size: 36px;
            margin-bottom: 8px;
        }

        p {
            font-size: 0.875rem;
            margin: 0;
        }
    }
}

.data-purchase {
    padding: 14px 20px 0px;
}

.diff-up {
    color: red;
    font-weight: bold;
}

.diff-down {
    font-weight: bold;
    color: green;
}

.unity {
    box-sizing: unset;

    .fa-edit {
        margin-left: 10px;
        color: var(--primary-color);
        cursor: pointer;
    }

    .unity-wrapper {
        display: inline-block;
        width: 86px;

        img {
            height: 18px;
        }

        input[type="number"] {
            border-radius: 10px 0 0 10px;
            border-width: 0;
            width: 50px;
            border: 4px solid #0606064d;
            display: inline-block;
            text-align: center;

            &:focus {
                border: 3px solid var(--primary-color);
                outline: none;
            }

            &.higher {
                background-color: #13c7213d;
            }

            &.lower {
                background-color: #13c7213d;
            }
        }

        button {
            background: none;
            border: none;
            display: flex;
            align-items: center;
            justify-content: center;

            .fa-arrow-up {
                color: #0033ef9e;
            }

            .fa-arrow-down {
                color: #fb7272;
            }

            &.save {
                float: right;
                color: green;
                height: 32px;
                padding: 4px;
                position: relative;
                left: -12px;
                border-left: none;
                width: 1.5rem;
                border-radius: 0px 10px 10px 0px !important;

                i {
                    border-color: #0606064d;
                    left: 0.4rem;
                    position: absolute;
                    font-size: 0.9rem;
                    margin: 0;
                }
            }
        }
    }
}

.data-analysis h4 select {
    background: none;
    border: none;
    outline: none;
}

.product-filter select:active {
    border: none;
}

.data-analysis h4 select:focus,
.data-analysis h4 select:active {
    border: none;
    outline: none;
    box-shadow: none;
}

.product-filter button {
    background: none;
    border: none;
    cursor: pointer;
}

.product-filter span {
    color: #3a3a3c;
    font-size: 0.875rem;
    font-weight: 400;
}

.product-actions {
    button {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 4px;
        border-radius: 4px;
        transition: background-color 0.2s ease;

        &:hover:not(:disabled) {
            background-color: rgba(0, 0, 0, 0.1);
        }

        &:disabled {
            opacity: 0.5;
            cursor: not-allowed;
        }

        .material-icons-outlined {
            font-size: 18px;
        }
    }
}

@media (max-width: 768px) {
    .modal-wrapper {
        width: 100%;
        margin: 0;
    }

    .modal-container {
        height: auto;
        max-height: 90vh;
    }

    .modal-header h2 {
        font-size: 1.1rem;
    }

    .tab-btn {
        padding: 8px 15px;
        font-size: 0.85rem;
    }

    .modal-details-product {
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
    }

    .cards-container {
        flex-direction: column;
    }

    .history-table {
        display: block;
        width: 100%;

        thead {
            display: none;
        }

        tbody {
            display: block;
            width: 100%;
        }

        tr {
            display: block;
            margin-bottom: 15px;
            border: 1px solid #ddd;
            border-radius: 5px;
            padding: 10px;
        }

        td {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 8px 10px;
            border-bottom: 1px solid #eee;
            text-align: right;

            &::before {
                content: attr(data-label);
                color: #333;
                margin-right: 15px;
            }
        }

        td:last-child {
            border-bottom: none;
        }
    }

    .space-modal {
        display: flex;
        flex-wrap: wrap;
    }
}

@media (max-width: 480px) {
    .modal-header {
        padding: 12px 15px;

        h2 {
            font-size: 1rem;
        }
    }

    .modal-body {
        padding: 15px;
    }

    .tab-btn {
        padding: 6px 10px;
        font-size: 0.8rem;
    }

    .history-table td {
        font-size: 0.85rem;
        padding: 6px 8px;
    }
}
</style>
